import styled from "styled-components";
import {Tabs, TabList, Tab, TabPanel} from "react-tabs"

export const WrapperTabs= styled(Tabs)`
font-size: 16px;
width: 100%;
margin-top: 16px;
padding-left: 5%;
`;
WrapperTabs.tabsRole ="Tabs";

export const WrapperTabList= styled(TabList)`
list-style-type: none;
padding: 4px;
display: flex ;
margin: 0;
`;
WrapperTabList.tabsRole ="TabList";


export const WrapperTab= styled(Tab)`
border-radius: 16px;
border: 1px solid #ccc;
padding: 8px;
user-select: none;
cursor: pointer;
margin: 8px;
padding: 16px;

&:focus{
    outline: none;
    
}

&.is-selected{
   
   box-shadow: 3px 2px 10px rgba(0 ,0 ,0 ,0.2);
}
`;
WrapperTab.tabsRole ="Tab";


export const WrapperTabPanel= styled(TabPanel)`
border: 1px solid "#ccc";
padding: 8px;
display:none;
margin-top: -5px;

&.is-selected{
   display: block;

}
`;
WrapperTabPanel.tabsRole ="TabPanel";

export const WrapperList = styled.div`
display: flex;
justify-content: flex-start;
flex-wrap: wrap;




`
